import { MyInfoType } from 'common/constants/my/myInfoType'
import { MySizeState } from 'common/ducks/my/personalInfo'
import { MySizeTarget } from 'common/types/entities/api/review'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export interface MyInfoParam {
  type: MyInfoType
  mySizeTargets?: MySizeTarget[]
  naverId?: string
  naverIdNo?: string
  isFirstRegister?: boolean
  headers?: any
}
export const fetchMyInfo = async ({ type, headers }: MyInfoParam) => {
  const result = await axios.get(`/v1/my-info/${type}`, {
    ...getHeaders(headers),
  })

  return result
}

export const saveMyInfo = async ({ type, mySizeTargets, isFirstRegister }: MyInfoParam, mySize: MySizeState) => {
  const result = await axios.put(
    `/v1/my-info/${type}`,
    {
      mySize,
      mySizeTargets,
    },
    {
      params: {
        isFirstRegister,
      },
    },
  )
  return result
}

export const deleteMyInfo = async ({ type }: MyInfoParam) => {
  const result = await axios.delete(`/v1/my-info/${type}`)
  return result && result.data
}
